<template>
  <div id="app">
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="/">基隆市中山國中第二十屆301班</a>
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <a class="nav-link" href="/">首頁 <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/guestbook">留言板</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/photo">生活剪影</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/news">最新消息</a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">--</a>
            </li>
            <li class="nav-item" v-if="token === null">
              <a class="nav-link" href="/login">登入</a>
            </li>
            <li class="nav-item" v-if="token !== null">
              <a class="nav-link" href="/guestbook/post">留言</a>
            </li>
            <li class="nav-item" v-if="token !== null">
              <a class="nav-link" href="/photo/post">照片上傳</a>
            </li>
            <li class="nav-item" v-if="token !== null">
              <div class="row">
                <div class="col-9"><a class="nav-link" href="/logout">登出({{ username }})</a></div>
                <div class="col-3"><a href="/account"><img :src="avatar" width="36" class="avatar" /></a></div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="row logo">
        <span class="logo-font">基隆市中山國中第二十屆301班</span><span class="logo-memo">(1990畢業)</span>
      </div>
      <router-view/>
    </div>
  </div>
</template>

<style>
  html {font-size:12px;}
  body {font-size: 1.2rem;}
  h1 {font-size:1.6rem;}
  h2 {font-size:1.3rem;}
  h3 {font-size:1.2rem;}
  .logo {
    width: 100%;
    padding:0.8rem;
  }
  .logo-font {
    font-size: 1.3rem;
    font-weight: bold;
    color: #666699;
  }
  .logo-memo {
    margin-left: 0.2rem;
    padding-top: 0.1rem;
  }
  .avatar {
    background-color: #0b2e13;
    border-radius: 50%;
  }
</style>
<script>
  import "bootstrap/dist/css/bootstrap.css";
  import "jquery";
  import "bootstrap";

  import Vue from 'vue'
  import VueCookies from 'vue-cookie'
  import CKEditor from "@ckeditor/ckeditor5-vue"
  import axios from "axios";
  Vue.use(VueCookies)
  Vue.use(CKEditor)

  const apiUrl = process.env.VUE_APP_GRAPHQL_URL;

  export default {
    name: 'App',
    data() {
      return {
        loadData: false,
        username: null,
        avatar: null,
        token: String,
        user: null,
        cookieUser: null
      }
    },
    mounted () {
      this.token = VueCookies.get('token');
      this.cookieUser = VueCookies.get('user');
      if (this.cookieUser === null && this.token !== null) {
        const queryString = `
{
  me {
    id
    name
    nickname
    avatar
  }
}
      `;
        axios
          .get(apiUrl + queryString, {headers: {Authorization: 'Bearer ' + this.token}})
          .then(response => {
            this.user = response.data.data.me
            this.username = (this.user.nickname == '') ? this.user.name : this.user.nickname
            this.avatar = this.user.avatar
            this.cookieUser = JSON.stringify(this.user)
            VueCookies.set('user', this.cookieUser);
          })
          .catch(error => console.log(error))
          .finally(() => this.loadData = true)
      } else {
        if (this.cookieUser !== null) {
          this.user = JSON.parse(this.cookieUser)
          this.username = (this.user.nickname == '') ? this.user.name : this.user.nickname
          this.avatar = this.user.avatar
        }
      }
    },
  }
</script>
